import { motivoDesistenciaService } from '../_services/';
import alerts from '../_components/alerts';

export const motivoDesistenciaAction = {
    getMotivoDesistencia,
    onChangeProps,
    clear,
    getSelectMotivos
};
function getMotivoDesistencia(showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'motivosDesistencias';
        motivoDesistenciaService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeMotivoDesistenciasList(response.data));
                // console.log("response.data", response.data);
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err.response);
                return err.response;
            })
    };
}

function getSelectMotivos(showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'fazendas/motivosDesistencias/select';
        motivoDesistenciaService.get(apiEndpoint)
            .then((response) => {
                response.data.unshift({ Value: '', Text: ' SELECIONE ...' });
                dispatch(changeMotivoDesistenciasList(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err.response);
                return err.response;
            })
    };
}

function onChangeProps(props, event) {
    return dispatch => {
        if (event.target.type == 'checkbox') {
            dispatch(handleOnChangeProps(props, event.target.checked));
        } else {
            dispatch(handleOnChangeProps(props, event.target.value));
        }
    };
}

export function changeMotivoDesistenciasList(motivoDesistencia) {
    return {
        type: "FETECHED_ALL_MOTIVO_DESISTENCIA",
        motivoDesistencia: motivoDesistencia
    }
}
export function clear() {
    return {
        type: "MOTIVO_DESISTENCIA_CLEAR"
    };
}
export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE",
        props: props,
        value: value
    }
}
export function editMotivoDesistenciasDetails(motivoDesistencia) {
    return {
        type: "MOTIVO_DESISTENCIA_DETAIL",
        id: motivoDesistencia.id,
        codigo: motivoDesistencia.codigo,
        nome: motivoDesistencia.nome,
        data_cadastro: motivoDesistencia.data_cadastro,
        data_exclusao: motivoDesistencia.data_exclusao,
        usuario_cadastro: motivoDesistencia.usuario_cadastro,
        usuario_exclusao: motivoDesistencia.usuario_exclusao
    }
}
export function updatedUserInfo() {
    return {
        type: "MOTIVO_DESISTENCIA_UPDATED"
    }
}
export function createUserInfo() {
    return {
        type: "MOTIVO_DESISTENCIA_CREATED_SUCCESSFULLY"
    }
}
export function deleteMotivoDesistenciasDetails() {
    return {
        type: "DELETED_MOTIVO_DESISTENCIA_DETAILS"
    }
}